import { render, staticRenderFns } from "./Forms1099CustomerView.vue?vue&type=template&id=28daf296&scoped=true&"
import script from "./Forms1099CustomerView.vue?vue&type=script&lang=ts&"
export * from "./Forms1099CustomerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28daf296",
  null
  
)

export default component.exports